<template>
  <div class="relative flex flex-col min-w-0 break-words w-full p-4 shadow-lg rounded-lg bg-white">
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h2 class="text-blueGray-700 text-xl font-semibold">
            <i class="fas fa-user-clock mr-1 text-blueGray-700"></i> Teaching Hours (Faculty of Medicine)
          </h2>
        </div>
      </div>
    </div>

    <div class="block overflow-x-auto w-full p-2">
        <table class="items-center w-full bg-blueGray-100 text-blueGray-600 border-collapse rounded-md shadow font-semibold">
          <tbody>
            <tr>
              <td class="border-t-0 p-2 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                200+ Hours
              </td>
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-right pr-12">
                {{ teacher_hour_arr.h_200 === '0' ? teacher_hour_arr.h_200 +' Person' : teacher_hour_arr.h_200 + ' Persons' }}
              </td>
            </tr>
            <tr>
              <td class="border-t-0 p-2 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                151 - 200 Hours
              </td>
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-right pr-12">
                {{ teacher_hour_arr.h_151 === '0' ? teacher_hour_arr.h_151 +' Person' : teacher_hour_arr.h_151 + ' Persons' }}
              </td>
            </tr>
            <tr>
              <td class="border-t-0 p-2 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                101 - 150 Hours
              </td>
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-right pr-12">
                {{ teacher_hour_arr.h_101 === '0' ? teacher_hour_arr.h_101 +' Person' : teacher_hour_arr.h_101 + ' Persons' }}
              </td>
            </tr>
            <tr>
              <td class="border-t-0 p-2 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                51 - 100 Hours
              </td>
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-right pr-12">
                {{ teacher_hour_arr.h_51 === '0' ? teacher_hour_arr.h_51 +' Person' : teacher_hour_arr.h_51 + ' Persons' }}
              </td>
            </tr>
            <tr>
              <td class="border-t-0 p-2 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                1 - 50 Hours
              </td>
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-right pr-12">
                {{ teacher_hour_arr.h_1 === '0' ? teacher_hour_arr.h_1 +' Person' : teacher_hour_arr.h_1 + ' Persons' }}
              </td>
            </tr>
            <tr>
              <td class="border-t-0 p-2 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                0 Hour
              </td>
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-right pr-12">
                {{ teacher_hour_arr.h_0 === '0' ? teacher_hour_arr.h_0 +' Person' : teacher_hour_arr.h_0 + ' Persons' }}
              </td>
            </tr>
          </tbody>
        </table>
    </div>
  </div>
</template>

<script>
import api from './../../services/student_services';

export default {
  data() {
    return {
      teacher_hour_arr: []      
    }
  },
  methods: {
    async teacher_hour() {
      api.teacher_hour().then(async (result) => {
        this.teacher_hour_arr = result.data;
      });
    },
  }, created: async function () {
    await this.teacher_hour()
  },
};
</script>